import { render } from "./ChangePassword.vue?vue&type=template&id=242055a8"
import script from "./ChangePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePassword.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/profile/components/ChangePassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "242055a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('242055a8', __exports__)) {
    api.reload('242055a8', __exports__)
  }
  
  module.hot.accept("./ChangePassword.vue?vue&type=template&id=242055a8", () => {
    api.rerender('242055a8', render)
  })

}


export default __exports__